<template>
  <!-- @deprecated 名人堂页, 26 赛季暂未上线, 由 teams/list.vue 里 v-show=false 强制隐藏; 目录整套 (index.vue / index.scss / video.vue) 保留供未来恢复 tab -->
  <div id="star">
    <div class="container">
      <div class="star-info">
        <div class="left-box" @click="switchStar('prev')">
          <div class="btn"></div>
        </div>
        <div class="info-box">
          <div class="bg">
            <div class="title-1"></div>
            <div class="title-2"></div>
          </div>
          <div class="basic">
            <div class="title">
              <span>{{ subStar.memberName || "-" }}</span>
              <div class="tap-btn">
                <a :href="subStar.tapLink" target="_blank" @click="clickTap"></a>
              </div>
            </div>
            <div class="des a" v-html="formatDes(subStar.memberDesc)"></div>
            <div class="fans">
              <div class="icon"></div>
              粉丝数 <span>{{ subStar.fans || "-" }}</span>
            </div>
            <div class="split-line"></div>
            <div
              class="video-btn"
              :class="{ hide: !subStar.videoId }"
              :style="{ 'background-image': `url(${subStar.cover})` }"
              @click="playVideo(subStar.videoId)"
            >
              <div class="play-btn"></div>
            </div>
          </div>
          <div class="star-box">
            <div
              class="star"
              :style="{ 'background-image': `url(${subStar.starAvatar})` }"
            ></div>
            <div
              class="shadow"
              :style="{ 'background-image': `url(${subStar.starAvatar})` }"
            ></div>
          </div>
          <div class="match">
            <div class="team">
              <div class="icon">
                <div
                  class="head"
                  :style="{ 'background-image': `url(${subStar.teamAvatar})` }"
                ></div>
              </div>
              <span>{{ subStar.teamName || "-" }}</span>
            </div>
            <div class="split-line"></div>
            <div class="base-data" ref="baseData"></div>
          </div>
        </div>
        <div class="right-box" @click="switchStar('next')">
          <div class="btn"></div>
        </div>
      </div>
      <div class="star-list">
        <ul class="inner" :style="{ width: `${17.14976 * starList.length}vh` }">
          <li
            v-for="(star, key) in starList"
            :key="key"
            :class="{ active: star.memberCode === subStar.memberCode }"
            @click="switchStar('list', star, key)"
          >
            <div
              class="thumb"
              :style="{ 'background-image': `url(${star.avatarThumbnail})` }"
            ></div>
          </li>
        </ul>
      </div>
    </div>
    <StarVideo ref="starVidoe"></StarVideo>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick } from "vue";
import * as api from "@/service/index";
import * as echarts from "echarts";
import anime from "animejs";
import { useAppStore } from '@/store'
import { getOption, updataOption } from "@/utils/initEcharts";
import StarVideo from "./video.vue";

const appStore = useAppStore();

const animition = ref(null);
const subKey = ref(0);
const subStar = ref({});
const starList = ref([]);

const option = ref({});
const myChart = ref(null);
const tempTime = ref(0);
const subSeasonID = ref('');

const baseData = ref(null);
const starVidoe = ref(null);

const token = computed(() => appStore.token);
const seasonInfo = computed(() => appStore.seasonInfo);

watch(
  seasonInfo,
  (newVal) => {
    if(newVal && newVal.id) {
      subSeasonID.value = newVal.id;
      // getStarList();
    }
  },
  { immediate: true, deep: true }
);

onMounted(() => {
  nextTick(() => {
    initEcharts();
    initAnime();
  });
});

function initEcharts() {
  let chartDom = baseData.value;
  myChart.value = echarts.init(chartDom);
  option.value = getOption(chartDom, 'member');
  option.value && myChart.value.setOption(option.value);
  chartDom.childNodes[0].style.position = "absolute";
}
function updataEcharts(subSeason) {
  option.value = updataOption(subSeason, option.value, "star");
  option.value && myChart.value.setOption(option.value);
}
function switchStar(type, info, key) {
  let newTime = new Date().getTime();
  if(newTime - tempTime.value >= 1 * 2000) {
    tempTime.value = newTime
  }else {
    return;
  }

  if(type === 'list') {
    subStar.value = info;
    subKey.value = key;
  }else if(type === 'prev') {
    if (subKey.value <= 0) {
      subKey.value = starList.value.length - 1;
    } else {
      subKey.value -= 1;
    }
    subStar.value = starList.value[subKey.value];
  }else if(type === 'next') {
    if (subKey.value >= starList.value.length - 1) {
      subKey.value = 0;
    } else {
      subKey.value += 1;
    }
    subStar.value = starList.value[subKey.value];
  }

  animition.value.restart();
  // 获取该明星选手的战斗数据
  if(!token.value) return;
  let data = {
    token: token.value,
    memberCode: subStar.value.memberCode,
    // seasonId: subSeasonID.value
    seasonId: 15
  };
  api.reqStarInfo(data).then((res) => {
    if (res.status === 200) {
      updataEcharts(res.data);
    }
  });

  // 埋点
  if(typeof tapdb === 'undefined') return;
  tapdb.trackEvent('点击选手信息', {
    '#star_id': subStar.value.memberName
  });
}
function playVideo(vid) {
  starVidoe.value.play(vid);
}
function formatDes(str) {
  return str?.replace(/\\n/g, '\n') || '-';
}
function clickTap() {
  // 埋点
  if(typeof tapdb === 'undefined') return;
  tapdb.trackEvent('点击选手TapTap按钮', {
    '#star_id': subStar.value.memberName
  });
}
function initAnime() {
  animition.value = anime.timeline({
    easing: "easeOutExpo",
    autoplay: false,
  });
  animition.value.add(
    {
      targets: ".star-box",
      translateX: [100, 0],
      opacity: [0, 1],
      duration: 1500,
    },
    0
  );
  animition.value.add(
    {
      targets: ".star-box .shadow",
      translateX: [-40, 0],
      scale: [1, 1.12],
      opacity: [0, 0.1],
      duration: 1500,
    },
    200
  );
  animition.value.add(
    {
      targets: ".basic .title",
      translateX: [40, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    500
  );
  animition.value.add(
    {
      targets: ".basic .title .tap-btn",
      translateX: [-100, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    500
  );
  animition.value.add(
    {
      targets: ".basic .des",
      translateX: [60, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    600
  );
  animition.value.add(
    {
      targets: ".basic .fans",
      translateX: [60, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    700
  );
  animition.value.add(
    {
      targets: ".basic .split-line",
      translateX: [60, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    700
  );
  animition.value.add(
    {
      targets: ".basic .video-btn",
      translateX: [60, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    800
  );
  animition.value.add(
    {
      targets: ".match .team",
      translateX: [-40, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    500
  );
  animition.value.add(
    {
      targets: ".match .base-data",
      translateX: [-40, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    600
  );
  animition.value.add(
    {
      targets: ".bg .title-1",
      translateX: [-150, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    200
  );
  animition.value.add(
    {
      targets: ".bg .title-2",
      translateX: [150, 0],
      opacity: [0, 1],
      duration: 1000,
    },
    300
  );
}
</script>

<style lang="scss" scoped>
@import "./index";
</style>
